/**
 * WISHLIST DUPPLICATE
 * 
 * module de gestion des duplications de wishlist
 * via une popin dans
 * la partie PRO de l'espace mon compte
 */
import $ from "jquery";
import { debounce } from 'throttle-debounce';
import { dialog } from "../../../../components/dialog";
const utils = require('../utils').default;

const WLDuplicate = (() => {
    const DOM_DUPLICATE = 'popin-duplicate-wishlist';
    const DOM_DUPLICATE_SHOW = `[data-js-dialog-open="${DOM_DUPLICATE}"]`;
    const DOM_DUPLICATE_POPIN = `[data-js-dialog-id="${DOM_DUPLICATE}"]`;
    const DOM_DUPLICATE_FORM = `${DOM_DUPLICATE_POPIN} input`;
    const DOM_DUPLICATE_FIELD = `${DOM_DUPLICATE_POPIN} .js-rename-wishlist-field`;
    const DOM_DUPLICATE_INPUT = `${DOM_DUPLICATE_POPIN} input`;
    const DOM_DUPLICATE_SUBMIT = `${DOM_DUPLICATE_POPIN} button[type="submit"]`;
    const DOM_ERROR = `${DOM_DUPLICATE_POPIN} label[for="rename"] .error`;
    const DOM_SUCCES = `${DOM_DUPLICATE_POPIN} label[for="rename"] .success`;

    const ERROR_LIST_NAME_TOO_LONG = 'Ce nom de liste est trop long.';
    const ERROR_LIST_NAME_EXIST = 'Ce nom de liste existe déjà.';
    const SUCCESS_LIST_DUPLICATE = 'Votre liste a bien été dupliqué.';

    /**
     * LIST NAME VALIDATION
     * 
     * verification de nouveau nom de liste
     * enabled/disabled du btn submit
     */
    const listNameValidation = () => {
        let input = $(DOM_DUPLICATE_INPUT);
        let listName = utils.slug(input.val());
        let error = false;
        if (listName.length > 30) {
            error = ERROR_LIST_NAME_TOO_LONG;
        } else if (window.WL.isWishlistExist(listName)) {
            error = ERROR_LIST_NAME_EXIST;
        }
        if (listName.length > 1 && !error) {
            $(DOM_DUPLICATE_SUBMIT).prop('disabled', false);
        } else {
            $(DOM_DUPLICATE_SUBMIT).prop('disabled', true);
        }
        showNotification(error, 'ERROR');
    };
    /**
     * POPIN OPEN (func)
     * 
     * Ouverture de la popin creation d'adresse
     */
    const popinOpen = (event) => {
        updateTemplates(event);
        listNameValidation();
        $(DOM_DUPLICATE_INPUT).off().on('keyup change', debounce(250, function(event) {
            listNameValidation();
        }));
        $(DOM_DUPLICATE_SUBMIT).off().on('click', duplicateList);
    };
    /**
     * DUPLICATE LIST
     * 
     * @param {event} event 
     */
    const duplicateList = (event) => {
        event.preventDefault();
        let input = $(DOM_DUPLICATE_INPUT);
        let listNewName = input.val();
        let listDuplicateId = $(DOM_DUPLICATE_FORM).data('wishlist-id');
        window.WL.createWishlist(listNewName);
        let listNew = window.WL.getWishlist(listNewName);
        let listDuplicate = window.WL.getWishlist(listDuplicateId);
        Object.assign(listNew, listDuplicate);
        listNew.name = listNewName;
        utils.dispatchCustomEvent('WISHLIST_HAS_CHANGED', {event: `List duplicated : ${listNewName}`});
        utils.dispatchCustomEvent('NOTIFICATION_DEFAULT', {content: SUCCESS_LIST_DUPLICATE, type: 'success'});
        utils.dispatchCustomEvent('TRACKERS_WISHLIST_DUPLICATE_LIST', {listNewId: utils.slug(listNewName), listDuplicateId});
        showNotification(SUCCESS_LIST_DUPLICATE, 'SUCCESS');
        dialog.close();
    };
    /**
     * SHOW NOTIFICATION
     * 
     * affichage des notifications
     * @param {string} notif 
     * @param {string} type 
     */
    const showNotification = (notif, type) => {
        $(DOM_DUPLICATE_FIELD).removeClass('c-form__field--error');
        $(DOM_DUPLICATE_FIELD).find('.c-form__error').text('');
        if ('ERROR' === type && notif) {
            $(DOM_DUPLICATE_FIELD).addClass('c-form__field--error');
            $(DOM_DUPLICATE_FIELD).find('.c-form__error').text(notif);
        } 
    };
    /**
     * UPDATE TEMPLATE (func)
     * 
     * Mise à jour du template de la popin 
     * de suppression d'adresse
     */
    const updateTemplates = (event) => {
        let data = {
            name: $(event.currentTarget).data('wishlist-name'),
            id: $(event.currentTarget).data('wishlist-id'),
        };
        utils.dispatchCustomEvent('TEMPLATE_POPIN_UPDATE', {popinTargetID: DOM_DUPLICATE, data});
    };
    /**
     * INIT (func)
     */
    const init = () => {
        utils.debug('WL DUPLICATE', 'initialisation'); 
        $(DOM_DUPLICATE_SHOW).off().on('click', popinOpen);
    }
    return {init}
})();
export default WLDuplicate;